import React from 'react';

import { useTranslation } from 'react-i18next';

import { Text } from 'components/Text';
import GlobalModal from 'modals/GlobalModal/GlobalModal';

interface ConfirmLogoutModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmLogoutModal: React.FC<ConfirmLogoutModalProps> = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation('common');

  return (
    <GlobalModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      onCancel={onClose}
      confirmButtonText={t('logout.confirm')}
      cancelButtonText={t('logout.cancel')}
      title={t('logout.title')}
    >
      <Text textAlign="left" size="medium" color="textPrimary">
        {t('logout.message')}
      </Text>
    </GlobalModal>
  );
};

export default ConfirmLogoutModal;
